import { useState } from 'react';
import './App.css';
import GameScreen from './components/GameScreen';
import NameEntry from './components/NameEntry';
import PortraitDebug from './components/PortraitDebug';
import { hasSave, loadState, clearSave } from './engine/save';
import { createInitialRuntime } from './engine/gameState';
import { generateCharacters } from './engine/charGen';
import { preRenderPortraits } from './engine/portraitRenderer';

function App() {
  const [screen, setScreen] = useState('menu');
  const [runtime, setRuntime] = useState(null);

  async function handleNewGame() {
    clearSave();
    setScreen('generating');
    const npcs = generateCharacters(100, ['camp_fire', 'forest_edge', 'camp_entrance', 'mine']);
    const initialRuntime = createInitialRuntime(npcs);
    const portraitDataUrls = await preRenderPortraits(initialRuntime.characters);
    const characters = { ...initialRuntime.characters };
    for (const [id, url] of Object.entries(portraitDataUrls)) {
      characters[id] = { ...characters[id], portraitData: url };
    }
    setRuntime({ ...initialRuntime, characters });
    setScreen('name-entry');
  }

  function handleContinue() {
    setRuntime(loadState());
    setScreen('game');
  }

  function handleNameConfirmed(name) {
    setRuntime(prev => ({
      ...prev,
      player: { ...prev.player, name },
    }));
    setScreen('game');
  }

  function handleQuit() {
    setScreen('menu');
  }

  if (screen === 'portrait-debug') {
    return <PortraitDebug onBack={() => setScreen('menu')} />;
  }

  if (screen === 'generating') {
    return (
      <div className="App">
        <div className="main-menu">
          <p className="generating-text">Generating world...</p>
        </div>
      </div>
    );
  }

  if (screen === 'name-entry') {
    return <NameEntry onConfirm={handleNameConfirmed} />;
  }

  if (screen === 'game') {
    return <GameScreen initialRuntime={runtime} onQuit={handleQuit} />;
  }

  const saveExists = hasSave();

  return (
    <div className="App">
      <div className="main-menu">
        <h1 className="title">New World</h1>
        <div className="menu-buttons">
          <button className="menu-btn" onClick={handleContinue} disabled={!saveExists} style={!saveExists ? { opacity: 0.3, cursor: 'default' } : {}}>Continue</button>
          <button className="menu-btn" onClick={handleNewGame}>New Game</button>
          <button className="menu-btn" disabled style={{ opacity: 0.3, cursor: 'default' }}>Load Game</button>
          <button className="menu-btn menu-btn--dev" onClick={() => setScreen('portrait-debug')}>Portrait Viewer [DEV]</button>
        </div>
      </div>
    </div>
  );
}

export default App;
